import $ from "jquery";
export var AlertMessages = function () {
    $('[data-modal="alert-msg-close"]').on('click', function () {
        var parentDiv = $(this).closest(".alert-message");
        parentDiv.attr('data-status', '');
    });
};
